import { styled, Box, Typography, Stack } from "@mui/material";
import { useTranslations } from "next-intl";

export const RootStyle = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: "0.5rem",
  padding: theme.spacing(2),
  width: "100%",
}));

interface StatCardProps {
  title: string;
  value?: string;
  prefix?: string;
  suffix?: string;
  change?: number;
}

export const StatCard = ({ title, value, prefix, suffix }: StatCardProps) => {
  const t = useTranslations();
  return (
    <RootStyle spacing={1}>
      <Typography fontSize="0.875rem" fontWeight="500">
        {t(title)}
      </Typography>
      <Box display="flex" gap="0.25rem">
        <Typography fontSize="0.875rem" fontWeight="500">
          {prefix}
        </Typography>
        <Box display="flex" alignItems="center" gap="0.25rem">
          <Typography fontSize="2rem" fontWeight="700">
            {value ?? "-"}
          </Typography>
          <Typography fontSize="1rem" fontWeight="400" color="grey.600">
            {suffix}
          </Typography>
        </Box>
      </Box>
    </RootStyle>
  );
};
